/* Simulador (portal nuevo): ventana como el Dock (C27), tarjetas con radio (C08), burbujas (C19), avisos (C14),
   píldoras excluyentes (C07), sección plegable (C10) y botones (C04). Colores con los tokens del tema; oscuro con su par. */
.root {
  --sim-surface: var(--surface, #fff);
  --sim-page: var(--canvas, #fbf8f5);
  --sim-thread: #f5efe9;
  --sim-text: var(--text, #2a2420);
  --sim-text-2: #6b615a;
  --sim-text-3: #756a62;
  --sim-line: #ece5de;
  --sim-control: var(--control-border, #978a80);
  --sim-hover: #f3ede7;
  --sim-secondary: #f5efeb;
  --sim-secondary-hover: #ece4dc;
  --sim-secondary-pressed: #e3d9cf;
  --sim-accent: oklch(0.55 0.14 40);
  --sim-accent-hover: oklch(0.49 0.14 40);
  --sim-accent-pressed: oklch(0.44 0.13 40);
  --sim-on-accent: #fff;
  --sim-tint: oklch(0.955 0.025 50);
  --sim-tint-border: oklch(0.85 0.06 45);
  --sim-tint-text: oklch(0.45 0.12 40);
  --sim-ai-soft: oklch(0.955 0.022 300);
  --sim-ai-text: oklch(0.45 0.13 300);
  --sim-neutral-soft: #f2ece6;
  --sim-own: oklch(0.945 0.035 55);
  --sim-error: oklch(0.5 0.17 25);
  --sim-error-soft: oklch(0.96 0.02 25);
  --sim-disabled: #b9aea5;
  --sim-send-disabled: #d9cfc6;
  --sim-float-shadow: 0 12px 32px rgb(42 36 32 / 0.14), 0 2px 6px rgb(42 36 32 / 0.06);
  --sim-focus: oklch(0.93 0.04 50);
  --sim-whatsapp: #25d366;
  color: var(--sim-text);
  font-family: var(--font, "Lexend", system-ui, sans-serif);
}
:global(:root[data-theme="dark"]) .root {
  --sim-thread: var(--canvas);
  --sim-text-2: var(--text-muted);
  --sim-text-3: var(--text-muted);
  --sim-line: var(--border);
  --sim-hover: var(--surface-muted);
  --sim-secondary: var(--surface-muted);
  --sim-secondary-hover: oklch(0.33 0.01 60);
  --sim-secondary-pressed: oklch(0.36 0.012 60);
  --sim-accent: var(--primary);
  --sim-accent-hover: var(--primary-hover, var(--primary));
  --sim-accent-pressed: var(--primary-hover, var(--primary));
  --sim-on-accent: #1e1a17;
  --sim-tint: oklch(0.3 0.05 45);
  --sim-tint-border: #e18e5d;
  --sim-tint-text: oklch(0.86 0.08 55);
  --sim-ai-soft: #302437;
  --sim-ai-text: #d6b8f4;
  --sim-neutral-soft: var(--surface-muted);
  --sim-own: #493024;
  --sim-error: var(--error);
  --sim-error-soft: oklch(0.3 0.05 25);
  --sim-disabled: oklch(0.6 0.01 60);
  --sim-send-disabled: oklch(0.35 0.01 60);
  --sim-float-shadow: var(--shadow-lg);
  --sim-focus: oklch(0.45 0.08 45);
}
@media (prefers-color-scheme: dark) {
  :global(:root[data-theme="system"]) .root {
    --sim-thread: var(--canvas);
    --sim-text-2: var(--text-muted);
    --sim-text-3: var(--text-muted);
    --sim-line: var(--border);
    --sim-hover: var(--surface-muted);
    --sim-secondary: var(--surface-muted);
    --sim-secondary-hover: oklch(0.33 0.01 60);
    --sim-secondary-pressed: oklch(0.36 0.012 60);
    --sim-accent: var(--primary);
    --sim-accent-hover: var(--primary-hover, var(--primary));
    --sim-accent-pressed: var(--primary-hover, var(--primary));
    --sim-on-accent: #1e1a17;
    --sim-tint: oklch(0.3 0.05 45);
    --sim-tint-border: #e18e5d;
    --sim-tint-text: oklch(0.86 0.08 55);
    --sim-ai-soft: #302437;
    --sim-ai-text: #d6b8f4;
    --sim-neutral-soft: var(--surface-muted);
    --sim-own: #493024;
    --sim-error: var(--error);
    --sim-error-soft: oklch(0.3 0.05 25);
    --sim-disabled: oklch(0.6 0.01 60);
    --sim-send-disabled: oklch(0.35 0.01 60);
    --sim-float-shadow: var(--shadow-lg);
    --sim-focus: oklch(0.45 0.08 45);
  }
}
/* :where para no pisar el tamaño de cada control (font: inherit trae solo la familia y el peso de Lexend). */
.root :where(button, input, textarea, select) {
  font: inherit;
}
.root :where(button, a, input, textarea, [tabindex]):focus-visible {
  outline: 3px solid var(--sim-focus);
  outline-offset: 2px;
}
.root svg {
  flex: none;
}

/* ── Minimizado: la herramienta del encabezado lleva las novedades (sin otro botón flotante, C27) ─────────────── */
:global(.shell-tool:has(> .shell-tool-badge)) {
  position: relative;
}
:global(.shell-tool > .shell-tool-badge) {
  position: absolute;
  top: 2px;
  right: 2px;
  display: grid;
  place-items: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background: oklch(0.55 0.14 40);
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
}
:global(:root[data-theme="dark"] .shell-tool > .shell-tool-badge) {
  background: var(--primary);
  color: #1e1a17;
}

/* ── Ventana ──────────────────────────────────────────────────────────────────────────────────────────────────── */
.backdrop,
.handle {
  display: none;
}
.window {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 41;
  display: flex;
  flex-direction: column;
  width: 420px;
  height: min(680px, calc(100dvh - 96px));
  overflow: hidden;
  border: 1px solid #e3dad2;
  border-radius: 16px;
  background: var(--sim-surface);
  box-shadow: 0 18px 48px rgb(42 36 32 / 0.18), 0 2px 8px rgb(42 36 32 / 0.08);
}
:global(:root[data-theme="dark"]) .window {
  border-color: var(--border);
}
/* Con el botón «Chats» a la vista, la ventana queda encima de él (C27: un flotante no tapa otro control). */
@media (min-width: 768px) {
  :global(body:has([data-chat-dock-launcher]:not([hidden]))) .root[data-state="FLOATING"] .window {
    bottom: 80px;
    height: min(680px, calc(100dvh - 156px));
  }
}
.head {
  display: flex;
  align-items: center;
  flex: none;
  gap: 8px;
  min-height: 56px;
  padding: 8px 8px 8px 16px;
  border-bottom: 1px solid var(--sim-line);
}
.headIcon {
  display: grid;
  place-items: center;
  width: 20px;
  height: 20px;
  color: var(--sim-accent);
}
.headIcon svg {
  width: 20px;
  height: 20px;
}
.title {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  white-space: nowrap;
}
.typeTag {
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 7px;
  border-radius: 6px;
  background: var(--sim-neutral-soft);
  color: var(--sim-text-2);
  font-size: 11.5px;
  font-weight: 600;
}
.controls {
  display: flex;
  align-items: center;
  gap: 2px;
  margin-inline-start: auto;
}
.iconButton {
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: var(--sim-text);
  cursor: pointer;
}
.iconButton svg {
  width: 18px;
  height: 18px;
}
@media (hover: hover) {
  .iconButton:hover {
    background: var(--sim-hover);
  }
}
.iconButton:active {
  background: var(--sim-secondary-hover);
}
.pin[aria-pressed="true"] {
  background: var(--sim-tint);
  color: var(--sim-tint-text);
}
/* Anclar solo donde la página conserva su ancho (como el Dock: 1200 px o más). */
@media (max-width: 1199px) {
  .pin {
    display: none;
  }
}
@media (min-width: 1200px) {
  .root[data-state="PINNED"] .window {
    top: var(--sim-top, var(--header-height, 56px));
    right: 0;
    bottom: 0;
    width: 420px;
    height: auto;
    border: 0;
    border-left: 1px solid var(--sim-line);
    border-radius: 0;
    box-shadow: none;
    z-index: 30;
  }
  :global(html[data-simulator-pinned] .app-shell .shell-main) {
    margin-right: 420px;
  }
  /* El botón «Chats» queda a la izquierda de la ventana anclada, sin tapar el cuadro de texto. */
  :global(html[data-simulator-pinned] .chat-dock-launcher) {
    right: 440px;
  }
}

/* ── Estados de la ventana (cargando, sin acceso, error) ─────────────────────────────────────────────────────── */
.state {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 24px 16px;
  color: var(--sim-text-2);
  font-size: 14px;
}
.state > .notice {
  width: 100%;
}
.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid var(--sim-line);
  border-top-color: var(--sim-accent);
  border-radius: 50%;
  animation: sim-spin 0.8s linear infinite;
}
@keyframes sim-spin {
  to {
    transform: rotate(360deg);
  }
}

/* ── Qué se prueba ─────────────────────────────────────────────────────────────────────────────────────────────── */
/* Antes del primer mensaje la ventana tiene un solo scroll: qué se prueba y, debajo, la invitación a escribir. */
.setupScroll {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  overflow-y: auto;
  background: var(--sim-thread);
  scrollbar-width: thin;
}
.setupScroll > .noticeSlot {
  padding-bottom: 8px;
  background: var(--sim-surface);
}
.setup {
  display: flex;
  flex: none;
  flex-direction: column;
  gap: 12px;
  padding: 12px 16px 16px;
  border-bottom: 1px solid var(--sim-line);
  background: var(--sim-surface);
}
.setupEmpty {
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-height: 96px;
  padding: 16px 12px;
  color: var(--sim-text-2);
  font-size: 13.5px;
  text-align: center;
}
.setupEmpty strong {
  color: var(--sim-text);
  font-size: 15px;
  font-weight: 600;
}
.fieldLabel {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
}
.cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-top: -4px;
}
.card {
  display: flex;
  gap: 10px;
  min-height: 64px;
  padding: 12px 14px;
  border: 1px solid var(--sim-control);
  border-radius: 12px;
  background: var(--sim-surface);
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
@media (hover: hover) {
  .card:hover {
    background: var(--sim-hover);
  }
}
.card[aria-checked="true"] {
  border-color: var(--sim-accent);
  background: var(--sim-tint);
  box-shadow: 0 0 0 1px var(--sim-accent);
}
.card[aria-disabled="true"] {
  cursor: not-allowed;
}
.radio {
  flex: none;
  width: 18px;
  height: 18px;
  margin-top: 1px;
  border: 1.5px solid var(--sim-control);
  border-radius: 50%;
  background: var(--sim-surface);
}
.card[aria-checked="true"] .radio {
  border-color: var(--sim-accent);
  background: radial-gradient(circle, var(--sim-accent) 0 4px, var(--sim-surface) 4.5px);
}
.cardText {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.cardTitle {
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--sim-text);
  font-size: 13.5px;
  font-weight: 600;
}
.cardTitle svg {
  width: 16px;
  height: 16px;
}
.aiIcon {
  color: var(--sim-ai-text);
}
.cardHelp {
  color: var(--sim-text-2);
  font-size: 12px;
  line-height: 1.35;
}
.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.field :global(.bh-choice-trigger) {
  border-color: var(--sim-control);
}
.help {
  display: block;
  margin: 0;
  color: var(--sim-text-2);
  font-size: 12.5px;
  line-height: 1.4;
}
.saved .secondary,
.notice .secondary {
  background: var(--sim-surface);
}
@media (hover: hover) {
  .saved .secondary:hover:not(:disabled),
  .notice .secondary:hover:not(:disabled) {
    background: var(--sim-secondary-hover);
  }
}
.saved {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px 12px;
  padding: 10px 12px;
  border-radius: 12px;
  background: var(--sim-neutral-soft);
  font-size: 13px;
}
.collapsible {
  display: flex;
  flex-direction: column;
}
.collapsibleHead {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 36px;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--sim-text);
  font-size: 14px;
  font-weight: 600;
  text-align: start;
  cursor: pointer;
}
.collapsibleHead svg {
  width: 16px;
  height: 16px;
  transform: rotate(-90deg);
  transition: transform 0.12s ease;
}
.collapsibleHead[aria-expanded="true"] svg {
  transform: none;
}
.collapsibleSummary {
  color: var(--sim-text-3);
  font-weight: 400;
}
.collapsibleBody {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 4px 0 0 24px;
}
.input {
  height: 42px;
  padding: 0 12px;
  border: 1px solid var(--sim-control);
  border-radius: 10px;
  background: var(--sim-surface);
  color: var(--sim-text);
  font-size: 14.5px;
}
.input:focus-visible {
  border-color: var(--sim-accent);
  outline: 3px solid var(--sim-focus);
  outline-offset: 0;
}
.safe {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 0;
  color: var(--sim-text-2);
  font-size: 12.5px;
  line-height: 1.4;
}
.safe svg {
  width: 16px;
  height: 16px;
  margin-top: 1px;
  color: var(--sim-text-3);
}

/* ── Con quién se habla y pestañas ───────────────────────────────────────────────────────────────────────────── */
.summary {
  display: flex;
  flex: none;
  flex-direction: column;
  gap: 10px;
  padding: 10px 16px 12px;
  border-bottom: 1px solid var(--sim-line);
}
.summaryRow {
  display: flex;
  align-items: center;
  gap: 10px;
}
.avatar {
  display: grid;
  flex: none;
  place-items: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
}
.avatar svg {
  width: 18px;
  height: 18px;
}
.avatarAi {
  background: var(--sim-ai-soft);
  color: var(--sim-ai-text);
}
.avatarChannel {
  background: var(--sim-whatsapp);
  color: #fff;
}
.avatarChannel svg {
  width: 20px;
  height: 20px;
  fill: currentColor;
  stroke: none;
}
.summaryText {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
}
.summaryText strong {
  overflow: hidden;
  font-size: 14.5px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.summaryText small {
  color: var(--sim-text-2);
  font-size: 12.5px;
}
.nowrap {
  white-space: nowrap;
}
.tabs {
  display: flex;
  gap: 8px;
}
.pill {
  display: inline-flex;
  align-items: center;
  height: 32px;
  padding: 0 12px;
  border: 1px solid var(--sim-control);
  border-radius: 999px;
  background: var(--sim-surface);
  color: var(--sim-text-2);
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
}
@media (hover: hover) {
  .pill:hover {
    background: var(--sim-hover);
  }
}
.pill[aria-pressed="true"] {
  border-color: var(--sim-tint-border);
  background: var(--sim-tint);
  color: var(--sim-tint-text);
}

/* ── Botón secundario (C04) ──────────────────────────────────────────────────────────────────────────────────── */
.secondary {
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 16px;
  border: 0;
  border-radius: 999px;
  background: var(--sim-secondary);
  color: var(--sim-text);
  font-size: 13.5px;
  font-weight: 600;
  white-space: nowrap;
  text-decoration: none;
  cursor: pointer;
}
.secondary svg {
  width: 16px;
  height: 16px;
}
@media (hover: hover) {
  .secondary:hover:not(:disabled) {
    background: var(--sim-secondary-hover);
  }
}
.secondary:active:not(:disabled) {
  background: var(--sim-secondary-pressed);
}
.secondary:disabled {
  color: var(--sim-disabled);
  cursor: not-allowed;
}

/* ── Avisos en línea (C14) ───────────────────────────────────────────────────────────────────────────────────── */
.noticeSlot {
  flex: none;
  padding: 8px 12px 0;
}
.notice {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 10px;
  padding: 10px 10px 10px 14px;
  border-radius: 16px;
  background: var(--sim-neutral-soft);
  color: var(--sim-text);
  font-size: 13.5px;
  line-height: 1.4;
}
.notice[data-tone="error"] {
  background: var(--sim-error-soft);
}
.notice > svg {
  width: 18px;
  height: 18px;
  color: var(--sim-text-2);
}
.notice[data-tone="error"] > svg {
  color: var(--sim-error);
}
.noticeText {
  flex: 1 1 180px;
  min-width: 0;
}
.noticeAction {
  display: flex;
  margin-inline-start: auto;
}

/* ── Hilo (C19) ──────────────────────────────────────────────────────────────────────────────────────────────── */
.threadWrap {
  position: relative;
  display: flex;
  flex: 1;
  min-height: 0;
  background: var(--sim-thread);
}
.thread {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 2px;
  min-height: 0;
  overflow-y: auto;
  padding: 12px 12px 8px;
  overflow-anchor: none;
  scrollbar-width: thin;
}
.thread:focus-visible {
  outline: none;
}
.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  margin: auto 0;
  padding: 24px 12px;
  color: var(--sim-text-2);
  font-size: 13.5px;
  text-align: center;
}
.empty strong {
  color: var(--sim-text);
  font-size: 15px;
  font-weight: 600;
}
.loadingRow {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px;
  color: var(--sim-text-2);
  font-size: 12.5px;
}
.dateRow {
  display: flex;
  justify-content: center;
  margin: 8px 0;
}
.dateRow span {
  padding: 3px 10px;
  border-radius: 8px;
  background: var(--sim-surface);
  color: var(--sim-text-2);
  font-size: 12px;
  box-shadow: 0 1px 1px rgb(42 36 32 / 0.07);
}
.messageRow {
  display: flex;
  margin-top: 4px;
}
.messageRow[data-own="true"] {
  justify-content: flex-end;
}
.bubble {
  display: flex;
  flex-direction: column;
  gap: 2px;
  max-width: 82%;
  padding: 6px 10px 7px;
  border-radius: 10px 10px 10px 3px;
  background: var(--sim-surface);
  box-shadow: 0 1px 1px rgb(42 36 32 / 0.07);
  font-size: 14px;
  line-height: 1.42;
  overflow-wrap: anywhere;
}
.bubble[data-own="true"] {
  border-radius: 10px 10px 3px 10px;
  background: var(--sim-own);
}
.sender {
  display: flex;
  align-items: center;
  gap: 4px;
  color: var(--sim-text-2);
  font-size: 12px;
  font-weight: 600;
}
.senderAi {
  color: var(--sim-ai-text);
}
.sender svg {
  width: 13px;
  height: 13px;
}
.quote {
  display: block;
  padding: 4px 8px;
  border-radius: 6px;
  background: rgb(42 36 32 / 0.05);
  color: var(--sim-text-2);
  font-size: 12.5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.body :global(p) {
  margin: 0;
}
.body :global(p + p),
.body :global(ul),
.body :global(ol) {
  margin: 4px 0 0;
}
.body :global(ul),
.body :global(ol) {
  padding-inline-start: 20px;
}
.body :global(a) {
  color: var(--sim-tint-text);
}
.body :global(code) {
  font-size: 13px;
}
.body {
  white-space: pre-wrap;
}
.body:has(:global(p)) {
  white-space: normal;
}
.meta {
  align-self: flex-end;
  color: var(--sim-text-3);
  font-size: 11px;
  line-height: 1.2;
}
/* C26: sobre la burbuja propia el gris terciario no llega a 4,5:1 (4,42); se usa el secundario. */
.bubble[data-own="true"] .meta {
  color: var(--sim-text-2);
}
.metaError {
  color: var(--sim-error);
  font-weight: 600;
}
.bubble[data-local="SENDING"] {
  opacity: 0.85;
}
.typing {
  display: flex;
  align-items: center;
  gap: 8px;
  align-self: flex-start;
  margin-top: 6px;
  padding: 6px 10px;
  border-radius: 10px 10px 10px 3px;
  background: var(--sim-surface);
  color: var(--sim-text-2);
  font-size: 12.5px;
  box-shadow: 0 1px 1px rgb(42 36 32 / 0.07);
}
.dots {
  display: inline-flex;
  gap: 3px;
}
.dots span {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--sim-text-3);
  animation: sim-dot 1.2s ease-in-out infinite;
}
.dots span:nth-child(2) {
  animation-delay: 0.15s;
}
.dots span:nth-child(3) {
  animation-delay: 0.3s;
}
@keyframes sim-dot {
  0%,
  60%,
  100% {
    opacity: 0.35;
  }
  30% {
    opacity: 1;
  }
}
.toEnd {
  position: absolute;
  right: 12px;
  bottom: 12px;
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  border: 0;
  border-radius: 50%;
  background: var(--sim-surface);
  color: var(--sim-text);
  box-shadow: var(--sim-float-shadow);
  cursor: pointer;
}
.toEnd svg {
  width: 18px;
  height: 18px;
}
.toEndBadge {
  position: absolute;
  top: -4px;
  right: -4px;
  display: grid;
  place-items: center;
  min-width: 20px;
  height: 20px;
  padding: 0 5px;
  border-radius: 999px;
  background: var(--sim-accent);
  color: var(--sim-on-accent);
  font-size: 11.5px;
  font-weight: 600;
}
.srOnly {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}

/* ── Cuadro de texto ─────────────────────────────────────────────────────────────────────────────────────────── */
.composer {
  display: flex;
  flex: none;
  flex-direction: column;
  gap: 4px;
  padding: 8px 12px 10px;
  background: var(--sim-thread);
}
.composerBox {
  display: flex;
  align-items: flex-end;
  gap: 6px;
  padding: 4px 4px 4px 14px;
  border-radius: 24px;
  background: var(--sim-surface);
  box-shadow: 0 1px 1px rgb(42 36 32 / 0.07);
}
.composerBox:focus-within {
  box-shadow: 0 0 0 1.5px var(--sim-accent);
}
.textarea {
  flex: 1;
  min-width: 0;
  min-height: 40px;
  max-height: 132px;
  padding: 9px 0;
  border: 0;
  background: transparent;
  color: var(--sim-text);
  font-size: 14.5px;
  line-height: 1.4;
  resize: none;
}
.root .textarea:focus-visible {
  outline: none;
}
.textarea::placeholder {
  color: var(--sim-text-3);
}
.send {
  display: grid;
  flex: none;
  place-items: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: var(--sim-accent);
  color: var(--sim-on-accent);
  cursor: pointer;
}
.send svg {
  width: 20px;
  height: 20px;
}
@media (hover: hover) {
  .send:hover:not(:disabled) {
    background: var(--sim-accent-hover);
  }
}
.send:active:not(:disabled) {
  background: var(--sim-accent-pressed);
}
.send:disabled {
  background: var(--sim-send-disabled);
  color: #fff;
  cursor: not-allowed;
}
:global(:root[data-theme="dark"]) .send:disabled {
  color: oklch(0.7 0.01 60);
}
.keyboardHelp {
  padding-inline-start: 14px;
  color: var(--sim-text-3);
  font-size: 11.5px;
}

/* ── Diagnóstico ─────────────────────────────────────────────────────────────────────────────────────────────── */
.diagnostic {
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 16px;
  min-height: 0;
  overflow-y: auto;
  padding: 12px 16px 16px;
}
.rows {
  display: flex;
  flex-direction: column;
  margin: 0;
}
.row {
  display: grid;
  grid-template-columns: minmax(120px, 40%) 1fr;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid var(--sim-line);
  font-size: 13.5px;
}
.row:last-child {
  border-bottom: 0;
}
.row dt {
  color: var(--sim-text-2);
}
.row dd {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  margin: 0;
  overflow-wrap: anywhere;
}
.attempts {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 4px 0 0;
  padding: 0 0 0 24px;
  list-style: none;
}
.attemptHead {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 8px;
  font-size: 13.5px;
}
.attemptModel {
  color: var(--sim-text-2);
  overflow-wrap: anywhere;
}
.tag {
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 7px;
  border-radius: 999px;
  background: var(--sim-neutral-soft);
  color: var(--sim-text-2);
  font-size: 11.5px;
  font-weight: 600;
}
.tag[data-status="ERROR"] {
  background: var(--sim-error-soft);
  color: var(--sim-error);
}
.attemptRows {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px 12px;
  margin: 6px 0 0;
  font-size: 12.5px;
}
.attemptRows dt {
  color: var(--sim-text-3);
}
.attemptRows dd {
  margin: 0;
}
.diagnosticActions {
  display: flex;
}
.toast {
  position: sticky;
  bottom: 0;
  align-self: center;
  width: max-content;
  max-width: 100%;
  padding: 10px 16px;
  border-radius: 999px;
  background: #2a2420;
  color: #fff;
  font-size: 13.5px;
}

/* ── Celular: hoja inferior (C27), sin anclar ────────────────────────────────────────────────────────────────── */
@media (max-width: 767px) {
  .backdrop {
    display: block;
    position: fixed;
    inset: 0;
    z-index: 50;
    background: rgb(42 36 32 / 0.35);
  }
  .window {
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 51;
    width: 100%;
    height: calc(100dvh * 0.88);
    border: 0;
    border-radius: 18px 18px 0 0;
    padding-bottom: env(safe-area-inset-bottom);
    animation: sim-sheet-up 90ms ease-out;
  }
  .handle {
    display: grid;
    flex: none;
    place-items: center;
    height: 20px;
  }
  .handle span {
    width: 36px;
    height: 4px;
    border-radius: 2px;
    background: #ddd3ca;
  }
  .head {
    min-height: 52px;
    padding-top: 0;
  }
  .iconButton {
    width: 44px;
    height: 44px;
  }
  .cards {
    grid-template-columns: 1fr;
  }
  .card {
    min-height: 56px;
  }
  .pill {
    height: 40px;
  }
  .secondary {
    height: 40px;
  }
  .send {
    width: 44px;
    height: 44px;
  }
  .keyboardHelp {
    display: none;
  }
}
@keyframes sim-sheet-up {
  from {
    transform: translateY(100%);
  }
  to {
    transform: none;
  }
}
@media (prefers-reduced-motion: reduce) {
  .window,
  .spinner,
  .dots span {
    animation: none;
  }
  .collapsibleHead svg {
    transition: none;
  }
}
